<template>
	<span>
		<!--
		<i :title="text">INFO</i>
		-->
	</span>
</template>

<script>
	export default {
		name: "HoverInfo",
		props: [
			"text"
		]
	}
</script>
